<template>
    <div id="app">
        <vue-toastr ref="toastr"></vue-toastr>
        <vue-confirm-dialog></vue-confirm-dialog>
        <portal-target name="semantic-ui-vue"></portal-target>

        <sui-menu
            is="sui-sidebar"
            :visible="$auth.isLogged.value && menuVisible"
            inverted
            vertical
            width="thin"
            animation="overlay"
            class="main-menu"
            >
            <sui-button icon="content" @click="menuVisible = !menuVisible" class="sidebar-toggle-menu tiny"  />

            <div class="menu-content">
                <div class="menu-content-items">
                    <router-link :to="{ name: 'CustomersList' }">
                        <sui-menu-item :active="this.$route.path.startsWith('/customers')">
                            <sui-icon name="building outline" />
                            {{ $t('common.customers') }}
                        </sui-menu-item>
                    </router-link>

                    <router-link :to="{ name: 'UsersList' }">
                        <sui-menu-item  :active="this.$route.path.startsWith('/users')">
                            <sui-icon name="users" />
                            {{ $t('common.users') }}
                        </sui-menu-item>
                    </router-link>

                    <router-link :to="{ name: 'GatewaysList' }">
                        <sui-menu-item :active="this.$route.path.startsWith('/gateways')">
                            <sui-icon name="database" />
                            {{ $t('common.transactionSoftwares') }}
                        </sui-menu-item>
                    </router-link>

                    <!-- 
                    Disable temporaly    
                    <router-link :to="{ name: 'ScreensLogsList' }">
                        <sui-menu-item  :active="this.$route.path.startsWith('/screens')">
                            <sui-icon name="file alternate" />
                            {{ $t('common.screensLogs') }}
                        </sui-menu-item>
                    </router-link> -->
                </div>

                <div class="menu-content-actions">
                    <LanguageSwitcher />

                    <AuthButton />
                </div>
            </div>

        </sui-menu>
        
        <sui-sidebar-pusher>
            <div id="main-container">
                <router-view />
            </div>
        </sui-sidebar-pusher>

        <iframe id="silentLoginIframe" style="width: 100%; width: 600px; display: none;"></iframe>
    </div>
</template>

<script>
    import store from '@/store';
    import { mapGetters } from 'vuex';
    import VueToastr from "vue-toastr";
    import LanguageSwitcher from './components/LanguageSwitcher.vue';

    export default {
        name: 'App',
        components: {
            VueToastr,
            LanguageSwitcher,
        },
        data() {
            return {
                appName: 'VM Monitoring',
                menuVisible: true,
            }
        },
        computed: {
            ...mapGetters(['appTitle']),
            state: {
                get() {
                    return store.state;
                },
            }
        },
        watch: {
            appTitle: {
                handler(appTitle) {
                    window.document.title = appTitle ? `${appTitle} - ${this.appName}` : this.appName;
                },
                immediate: true,
            }
        },
    };
</script>

<style>
    #app {
        height: 100%;
        top:0
    }

    .sidebar-toggle-menu {
        position: absolute !important;
        top: 30px !important;
        right: -30px !important;
        background-color: rgb(27, 28, 29) !important;
        color: white !important;
        padding-left: 6px !important;
    }

    body {
        height: auto !important;
        overflow-x: auto !important;
    }

    #main-container {
        margin: 15px 15px 15px 35px;
    }

    .ui.sidebar.vertical.main-menu {
        overflow-y: visible !important;
        visibility: visible !important;
    }

    /* Force large width for scrolling horizontaly into their complex ui */
    .large-content {
        min-width: 1300px;
    }

    .ui.sidebar.visible ~ .pusher {
        width: calc(100% - 260px);
        margin-left: 260px;
    }

    .ui.sidebar.visible {
        width: 260px !important;
    }

    .preformated-input-list :not(:first-of-type) {
        font-family: "Consolas";
        color: gray;
    }

    .preformated-input-list .item:first-of-type::before {
        content: '' !important;
    }

    .float-right {
        float: right;
    }

    .header-container {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }

    .menu-content {
        display: flex;
        flex-direction: column;
        align-content: space-between;
        height: 100%;
        width: 100%;
    }
    .menu-content .menu-content-items {
        flex: 1;
    }
    .menu-content .menu-content-actions {
        text-align: center;
        padding: 30px;
    }

    .no-bullet {
        margin-left: 0 !important;
    }

</style>
